/**
 * Base Accessibility Enhancer
 * Lightweight generic class for DOM observation and enhancement
 */

export default class BaseA11yEnhancer {
    constructor({ selector, enhance, observeDOM = true, delay = 100 }) {
        this.selector = selector;
        this.enhanceElement = enhance;
        this.enhanced = new WeakSet();

        document.querySelectorAll(selector).forEach((el) => this.process(el));

        if (observeDOM) {
            let timer;
            new MutationObserver(() => {
                clearTimeout(timer);
                timer = setTimeout(() => this.scan(), delay);
            }).observe(document.body, { childList: true, subtree: true });
        }
    }

    scan() {
        document.querySelectorAll(this.selector).forEach((el) => this.process(el));
    }

    process(el) {
        if (this.enhanced.has(el)) return;
        this.enhanced.add(el);
        this.enhanceElement(el);
    }
}
